import type { SVGProps } from "react";
const SvgClock04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M10 18.333a8.333 8.333 0 0 0 0-16.666c-3.731 0-6.855 2.452-7.917 5.833h2.084"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M10 6.667V10l1.667 1.667M1.667 10q0 .423.037.833m5.796 7.5a8 8 0 0 1-.833-.326m-3.992-3.84q-.242-.465-.43-.962m1.781 2.884q.383.412.814.769"
    />
  </svg>
);
export default SvgClock04;
